import {
  language_item,
  logout_item,
  profile_item,
  support_item,
} from '../../../../../components/layout/ProfileDropdown';

export default {
  items: {
    [profile_item]: 'Profilo',
    [language_item]: 'Cambia lingua',
    [support_item]: 'Supporto',
    [logout_item]: 'Esci',
  },
};
